import * as actionTypes from '../actions/actionTypes';

const initialState = {
    detail: null,
    loading: null,
    error: null
};

const reducer = (state = initialState, action) => {
    switch(action.type){
        case actionTypes.ADD_TICKET_DETAIL_INITIALIZE:
            return {
                ...state,
                loading: null,
                error: null,
                detail: null
            };
        case actionTypes.ADD_TICKET_DETAIL_LOADING:
            return {
                ...state,
                loading: true,
                error: null,
                detail: null
            };
        case actionTypes.ADD_TICKET_DETAIL_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                detail: null
            };
        case actionTypes.ADD_TICKET_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                detail: action.payload
            };
        default:
            return state;
    }
};

export default reducer;